// import { GetMerchantInfo } from '@/api/merchant/index'
import { PostLogin, PostLoginPassword, GetLastBalance, PostGetWalletUserBaseInfo } from '@/api/user/index'
// import { fetchUnreadNotificationCount } from '@/api/notification/index'
import ConstData from '@/constants/ConstData'
import { storage } from '@/utils/storage-times.js'
import { PostGetWalletUserInfoJt, PostGetWalletUserInfo } from '@/api/settings'
import { cryptoJSAesDecrypt } from '@/utils/cryptoJS'
// const dsBridge = require('dsbridge')
const initState = () => ({
  tokenJT: storage.get(ConstData.STORAGE.TOKEN_JT),
  token: storage.get(ConstData.STORAGE.TOKEN),
  userInfo: {}, //只是首页的基础信息
  payInfo: {}, //支付预存信息
  detailUserInfo: {}, //用户详细的信息
  userAmountInfo: {},
  ekycUserInfo: {}
})
const state = initState()
const mutations = {
  CHANGE_STATE: (state, { key, value }) => {
    // eslint-disable-next-line no-prototype-builtins
    if (state.hasOwnProperty(key)) {
      state[key] = value
    }
  },
  SET_TOKEN: (state, token) => {
    state.token = token
    storage.set(ConstData.STORAGE.TOKEN, token, '0n')
  },
  SET_TOKEN_JT: (state, token) => {
    state.tokenJT = token
    storage.set(ConstData.STORAGE.TOKEN_JT, token, '0n')
  },
  REMOVE_TOKEN_JT: state => {
    state.tokenJT = ''
    storage.remove(ConstData.STORAGE.TOKEN_JT)
  },
  REMOVE_TOKEN: state => {
    state.token = ''
    storage.remove(ConstData.STORAGE.TOKEN)
  },
  SET_USERINFO: (state, userInfo) => {
    state.userInfo = userInfo
  },
  SET_PAY_INFO: (state, payInfo) => {
    state.payInfo = payInfo
  },
  SET_DETAIL_USERINFO: (state, detailUserInfo) => {
    state.detailUserInfo = detailUserInfo
  },
  SET_EKYC_USERINFO: (state, ekycUserInfo) => {
    state.ekycUserInfo = ekycUserInfo
  },
  RESET_STATE: state => {
    Object.assign(state, initState())
  }
}
const actions = {
  login({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      const reuqest = params.password ? PostLoginPassword : PostLogin
      reuqest(params)
        .then(res => {
          const { data } = res
          if (data.token) {
            console.log('data.token = ' + data.token)
            commit('SET_TOKEN', data.token)
            storage.set(ConstData.STORAGE.TOKEN, data.token)
            // const json = {
            //   'key': ConstData.STORAGE.TOKEN,
            //   'value': data.token
            // }
            // dsBridge.call('jsapi.save2Sp', JSON.stringify(json))
            resolve(res)
          } else {
            reject({ code: 2 })
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  logout({ commit, dispatch }) {
    commit('REMOVE_TOKEN')
    commit('RESET_STATE')
    if (process.env.VUE_APP_PLATFORM !== 'jtwallet') {
      storage.clear(false)
    }
    // storage.clear(false)
    // const json = {
    //   'key': ConstData.STORAGE.TOKEN,
    //   'value': ''
    // }
    // dsBridge.call('jsapi.save2Sp', JSON.stringify(json))
    // const save_account = localStorage.getItem(ConstData.STORAGE.A_CC)
    // const save_ps = localStorage.getItem(ConstData.STORAGE.P_CC)
    // localStorage.clear()
    // localStorage.setItem(ConstData.STORAGE.A_CC, save_account)
    // localStorage.setItem(ConstData.STORAGE.P_CC, save_ps)
  },
  getInfo({ commit }) {
    return new Promise((resolve, reject) => {
      PostGetWalletUserBaseInfo()
        .then(response => {
          const { data } = response
          commit('SET_USERINFO', data)
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getUserBalance({ commit, state }) {
    return new Promise((resolve, reject) => {
      GetLastBalance({})
        .then(response => {
          const { data } = response
          commit('CHANGE_STATE', { key: 'userAmountInfo', value: data || {} })
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  getDetailWalletUserInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      PostGetWalletUserInfo({})
        .then(response => {
          const { data } = response
          if (data == null) {
            resolve(data)
            return
          }
          commit('SET_DETAIL_USERINFO', data)
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  getWalletUserInfoJt({ commit, state }) {
    return new Promise((resolve, reject) => {
      PostGetWalletUserInfoJt({})
        .then(response => {
          const { data } = response
          if (data == null) {
            resolve(data)
            return
          }
          const { id_photo_front_oss_url, id_photo_back_oss_url, id_human_photo_oss_url, sign_photo_oss_url } = data
          const idPhotoFont = cryptoJSAesDecrypt(id_photo_front_oss_url)
          const idPhotoBack = cryptoJSAesDecrypt(id_photo_back_oss_url)
          const idHumanPhoto = cryptoJSAesDecrypt(id_human_photo_oss_url)
          const signPhoto = cryptoJSAesDecrypt(sign_photo_oss_url)
          data.id_photo_front_oss_url = idPhotoFont
          data.id_photo_back_oss_url = idPhotoBack
          data.id_human_photo_oss_url = idHumanPhoto
          data.sign_photo_oss_url = signPhoto
          commit('SET_DETAIL_USERINFO', data)
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}
